<template>
    <div class="">
        <button type="button" id="btn_permission" @click="permissao">Permission</button>
        <button type="button" id="btn_push" @click="spawnNotification">Push Notification</button>
        {{ location.coords.latitude }}, {{ location.coords.longitude }}
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'

export default {
    name: 'dev',
    data: function() {
        return {
            location:null,
			errorStr:null
        }
    },
    methods: {
        permissao() {
            Notification.requestPermission()
        },
        spawnNotification() {
            const tipo = `?tipo=novoCliente`
            const destinoNome = `&destinoNome=Fabricio Andrade`
            axios.get(`${baseApiUrl}/backend/pushCliente.php${tipo}${destinoNome}`).then((res) => {
                const opt = {
                    body: res.data['body'],
                    icon: 'https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png'
                }
                const title = res.data['title']
                const link = res.data['link']
                const n = new Notification(title, opt)
                n.addEventListener("click", function() {               
                    window.location.href = link
                    n.close()
                    window.focus()
                })
                })
        },
        getLocation() {
			if(!("geolocation" in navigator)) {
				this.errorStr = 'Geolocation is not available.';
				return;
			}
			navigator.geolocation.getCurrentPosition(pos => {
				this.location = pos;
			})
		}
        
    },
    mounted() {
        this.getLocation()
    }
}
</script>

<style>
</style>
